<script lang="ts">
	import { Image, type ImageProps } from "@unpic/svelte";
	import { ImagePlaceholder } from "flowbite-svelte-v1";
	import { getContext, type Snippet } from "svelte";
	import { twMerge } from "tailwind-merge";
	import type { Point } from "#gen/bundles/v1/common_pb.js";
	import { transformURL } from "#lib/image.ts";
	import type { TokenProvider } from "#lib/tokenProvider.ts";
	import type { Writable } from "svelte/store";

	type Props = ImageProps & {
		focalPoint?: Point;
		badgeClass?: string;
		onerror?: () => void;
		placeholderSnippet?: Snippet;
		[key: string]: unknown;
	};

	const provider: Writable<TokenProvider> = getContext("tokenProvider");

	const { src, focalPoint = undefined, style = "", class: className, onerror = () => (invalid = true), placeholderSnippet, ...imageProps }: Props = $props();

	let invalid = $state(false);

	$effect(() => {
		if (src) {
			invalid = false;
		}
	});
</script>

{#snippet placeholder()}
	{#if placeholderSnippet}
		{@render placeholderSnippet()}
	{:else}
		<ImagePlaceholder size="sm" imgOnly={true} class={twMerge("h-full w-full animate-none", className as string)} classes={{ image: "h-full sm:w-full w-full bg-gray-50 m-0", svg: "h-6 w-6 text-gray-400" }} />
	{/if}
{/snippet}

<div class="relative flex h-full w-full">
	{#if src && !invalid}
		{#if $provider?.hasSubstitutionToken(src)}
			{@render placeholder()}
		{:else}
			<Image {...imageProps} src={transformURL(src)} class={className} style={`object-fit: cover; object-position: ${focalPoint ? `${focalPoint.x * 100}% ${focalPoint.y * 100}%` : "center"}; ${style}`} {onerror} />
		{/if}
	{:else}
		{@render placeholder()}
	{/if}
</div>
